export { default } from "./Slide.mjs";